import { createContext } from 'react';

export const WindowWidthContext = createContext(null);
